module.exports = __webpack_public_path__ + "static/images/components/LoadingScreen/images/window-bg.d5357bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./components/LoadingScreen/images/window-bg.jpg
// module id = 2608
// module chunks = 11